import { Tile } from "../../../../components/Tile";
import { styled } from "../../../../styles";

/**
 * Deliberately the same shell and metrics as PreferencesSection, which sits directly above it:
 * the two read as one page rather than two differently-built cards.
 */
export const SectionContainer = styled("div", {
  paddingTop: "48px",
});

export const LanguageContainer = styled(Tile, {
  width: "100%",
  minHeight: "140px",
  height: "100%",

  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  flexWrap: "wrap",

  backgroundColor: "$white",
  marginTop: "6px",
  padding: "28px 200px 30px 55px",
  fontSize: "14px",
  fontWeight: "500",
  color: "#666666",
});

export const LanguageRow = styled("div", {
  minWidth: "450px",
  height: "48px",

  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "16px",

  margin: "6px 10px 6px 0",
});

export const LanguageTitle = styled("p", {
  width: "170px",
});
